module.exports = __webpack_public_path__ + "img/icon_tw.47c41b89.png";